import type { ApiClientV2 } from 'utils/api-client/api-client.utils'

export interface InstallmentEligibility {
  allowed: boolean
  reason?: string
}

interface InstallmentEligibilityParams {
  sellerUsername: string
  countryCode: string
  customerType: 'business' | 'private'
  company?: string
  vatId?: string
}

export const createInstallmentEligibilityApi = ({ POST }: ApiClientV2) => ({
  checkEligibility: (data: InstallmentEligibilityParams) =>
    POST<InstallmentEligibility>('common/installment_eligibility', { type: 'installment_eligibility', ...data }),
})

export type InstallmentEligibilityApi = ReturnType<typeof createInstallmentEligibilityApi>
